<template>
    <div class="shopping-container">
        <div class="sidebar-top">
            <i class="fa fa-shopping-cart iconCart"></i>
            <h1 class="title">Carrinho</h1>
        </div>

        <div class="total-container">
            <p class="total-text">Recorrente</p>
            <div class="total-number-container">
                <span class="total-number">{{ displaySubtotal }}</span>
                <span class="mes">/mês</span>
            </div>
        </div>

        <div class="itemsList">
            <template v-if="cotacao">
                <div v-for="item in cotacao.itens" :key="item.plan_id + '-' + (item.plano_base || 0)" class="plan-container">
                    <h2 class="title">
                        {{ item.name }}
                        <span>{{ item.qtd }}x</span>
                    </h2>
                    <p v-if="item.plano_base_nome" class="local">Plano familiar {{ item.plano_base_nome }}</p>
                    <span class="planPrice">
                        <span v-if="item.desconto_unitario > 0" class="oldPrice">{{ toMoney(item.valor_bruto / 100) }}</span>
                        {{ toMoney(item.valor_unitario / 100) }}<span class="mes">/mês</span>
                    </span>
                </div>
            </template>
            <template v-else>
                <template v-for="(plan, index) in shoppingCar.plans">
                    <ShoppingCarDetailsCard :plan="plan" :key="index" />
                </template>
            </template>
            <div v-if="plansCount === 0" style="text-align: center; color: #999; padding: 1rem;">
                <p>Nenhum plano selecionado</p>
            </div>
        </div>

        <div class="price-container">
            <div class="data-container">
                <p class="data-text">Taxa de adesão</p>
                <span class="data-number">{{ displayAdesao }}</span>
            </div>
            <div class="data-container" v-if="displayDesconto && displayDesconto !== 'R$ 0,00'">
                <p class="data-text">Desconto</p>
                <span class="data-number" >-{{ displayDesconto }}</span>
            </div>
            <div class="data-total-container">
                <p class="total-text">Total</p>
                <div class="total-number-container">
                    <span class="total-number">{{ displayTotal }}</span>
                    <span class="mes">/mês</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toMoney } from '@/utils/formater';
import ShoppingCarDetailsCard from './ShoppingCarDetailsCard.vue';

export default {
    name: "ShoppingCarDetails",
    props: {
        shoppingCar: {
            type: Object,
            required: true,
            default: () => ({
                plans: [],
                total: 0,
                subtotal: 0,
                adesao: 0,
                desconto: 0
            })
        },
        // Valores calculados pelo servidor (descontos do plano e do plano familiar). Quando ausente, usa o cálculo local.
        cotacao: {
            type: Object,
            default: null
        },
    },
    components: {
        ShoppingCarDetailsCard
    },
    computed: {
        totalBase() {
            return this.shoppingCar.plans.reduce((acc, plan) => {
                return acc + (Math.floor(plan.price) * plan.qtd);
            }, 0);
        },

        totalDesconto() {
            return this.shoppingCar.plans.reduce((acc, plan) => {
                if (plan.tipo_desconto === "porcentagem") {
                    // Math.round evita que 10.5 centavos virem 10.500000000004
                    const valorBruto = plan.price * plan.qtd;
                    const desconto = Math.floor(valorBruto * (plan.valor_desconto / 100));
                    return acc + desconto;
                } else {
                    return acc + Math.floor(plan.valor_desconto || 0);
                }
            }, 0);
        },

        displayTotal() {
            if (this.cotacao) return toMoney(this.cotacao.totais.total / 100);
            return toMoney((this.totalBase / 100)+(this.shoppingCar.adesao / 100)- (this.totalDesconto / 100));
        },

        displayAdesao() {
            if (this.cotacao) return toMoney(this.cotacao.totais.adesao / 100);
            return toMoney(this.shoppingCar.adesao / 100);
        },

        displayDesconto() {
            if (this.cotacao) return toMoney(this.cotacao.totais.desconto / 100);
            return toMoney(this.totalDesconto / 100);
        },

        displaySubtotal() {
            if (this.cotacao) return toMoney(this.cotacao.totais.recorrente / 100);
            const subtotal = this.totalBase - this.totalDesconto;
            return toMoney(subtotal / 100);
        },

        plansCount() {
            return this.cotacao ? this.cotacao.itens.length : this.shoppingCar.plans.length;
        }
    },
/*     watch: {
        shoppingCar: {
            handler(newVal) {
                console.log('ShoppingCar foi atualizado:', newVal);
            },
            deep: true
        },
        'shoppingCar.plans': {
            handler(newVal) {
                console.log('Planos foram atualizados:', newVal);
            },
            deep: true
        },
        'shoppingCar.total': {
            handler(newVal) {
                console.log('Total foi atualizado:', newVal);
            }
        },
        'shoppingCar.subtotal': {
            handler(newVal) {
                console.log('Subtotal foi atualizado:', newVal);
            }
        },
        'shoppingCar.adesao': {
            handler(newVal) {
                console.log('Adesão foi atualizada:', newVal);
            }
        }
    }, */
    methods: {
        toMoney,
        NumberToMoney(value) {
            //console.log('Shopping Car:', this.shoppingCar);
            return toMoney(value);
        }
    }
}
</script>

<style scoped>
    .hasShoppingCar{
        height: auto !important;
        overflow: none !important;
        z-index: 40;
        box-shadow: 0 0 20px 1px rgb(160, 160, 160);
    }
    .shopping-container{
        position: relative;
        background-color: #fff;
        width: 100%;
        height: 33rem;
        display: grid;
        grid-template-rows: 4.8875rem 3.0625rem 1fr 7.3875rem;
        border: 1px solid #edebeb;
    }

    .sidebar-top-mobile{
        display: flex;
        align-items: center;
        position: relative;
        padding: 1.1rem 1rem;
    }
    .sidebar-top{
        display: flex;
        align-items: center;
        position: relative;
        padding: 2rem;
        color: #c90c53;
    }

    .icon-mobile{
        font-size: 28px;
    }
    .icon{
        font-size: 28px;
    }

    .title-mobile{
        color: #000;
        font-size: .875rem;
        font-weight: 500;
        margin-left: 3rem;
        margin-bottom: .25rem;
    }
    .title{
        font-size: 1.1875rem;
        font-weight: 700;
        margin-left: 1rem;
        margin-bottom: 0;
    }

    .total-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f8f7f7;
        padding: .5rem 2rem;
    }

    .total-number-container{
        display: flex;
        align-items: center;
    }

    .total-text{
        color: #000;
        font-size: .875rem;
        font-weight: 700;
        margin: 0;
    }

    .total-number-mobile{
        color: #c90c53;
        font-size: .9375rem;
        font-weight: 500;
        text-transform: uppercase;
        margin-left: 3rem;
    }
    .total-number{
        color: #c90c53;
        font-size: 1.375rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    .mes{
        color: #747474;
        font-size: .75rem;
        font-weight: 500;
        text-transform: lowercase;
        display: block;
        margin-left: .3125rem;
    }

    .itemsList{
        margin: 1rem 2rem;
        overflow-y: auto;
    }

    .data-container, .data-total-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .5rem 2rem;
    }
    .data-total-container{
        background-color: #f8f7f7;
    }

    .data-text{
        color: #000;
        font-size: .75rem;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 0;
        display: flex;
        align-items: center;
    }

    .data-number{
        color: #c90c53;
        font-size: .75rem;
        font-weight: 500;
        text-transform: uppercase;
        line-height: normal;
    }

    .iconInfo{
        font-size: 1.2rem;
        margin-left: .4rem;
        user-select: none;
    }

    .loja-mobile{
        position: relative;
    }

    .total-card-mobile{
        color: #000000;
        font-size: 12px;
        font-weight: 700;
        line-height: 20px;
        width: 23px;
        height: 23px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #00fff5;
        border-radius: 50%;
        position: absolute;
        top: -9px;
        right: -15px;
        cursor: pointer;
        margin-top: .1rem;
    }

    .iconArrow{
        color: #FF6EA9;
        font-size: 2rem;
        cursor: pointer;
        user-select: none;
        position: absolute;
        right: 1rem;
        top: 1.2rem;
    }

    .iconCart{
        font-size: 1.5rem;
    }

    .plan-container{
        text-align: left;
        margin: 1.5rem 0;
    }
    .plan-container .title{
        color: #000;
        font-size: 1.0625rem;
        font-weight: 600;
        margin-bottom: 0;
    }
    .plan-container .local{
        color: #747474;
        font-size: .75rem;
        margin: .25rem 0;
    }
    .plan-container .planPrice{
        color: #c90c53;
        font-size: 1rem;
        font-weight: 600;
    }
    .oldPrice{
        color: #999;
        font-weight: 400;
        text-decoration: line-through;
        margin-right: .5rem;
    }

    @media screen and (max-width: 500px) {
        .content-container{
            width: 100%;
        }

        .sidebar-top{
            padding: 2rem 1.5rem 0 1.5rem;
        }

        .iconClose{
            right: 1.5rem;
            top: 2rem;
        }

        .total-container{
            padding: .5rem 1.5rem;
        }

        .itemsList{
            margin: 1.5rem;
        }

        .data-container, .data-total-container{
            padding: .5rem 1.5rem;
        }
    }

    @media screen and (max-width: 767.9px){
        .shopping-container{
            margin-top: 4rem;
        }
    }
</style>